<template>
    <div class="errors-container" v-if="appErrors.length">
        <snackbar v-for="(error, index) in appErrors" :open="error.open" :key="index" @closed="closed(index)">
            {{error.message}}
        </snackbar>
    </div>
</template>

<script>
    import Mixins from '../../mixins/mixins';
    import Snackbar from './snackbar.vue';
    import {mapGetters} from "vuex";

    export default {
        components: {Snackbar},
        computed: {
            ...mapGetters({
                appErrors: 'errors/getAll'
            }),
        },
        methods: {
            closed(index) {
                console.log('closed');
                this.$store.dispatch('errors/acknowledge', index);
            }
        },
        mixins: [Mixins]
    }

</script>